@if (loadingService.isLoading()) {
  <div class="loader-overlay">
    <div class="loader-container">
      <div class="spinner"></div>
      <p>Loading...</p>
    </div>
  </div>
}